export const LESSON_TEACH_TITLE = 'Teach'
export const BUTTON_SUPERTITLE = 'View'
export const SLM_TITLE = 'Streaming Lesson Media'
export const SCRIPT_TITLE = 'Lesson Script'
